<template>
	<v-app class="forsa-app" :dir="locale === 'ar' ? 'rtl' : 'ltr'">
		<div>
			<!-- Navigation Bar -->
			<v-app-bar
				app
				color="white"
				flat
				class="forsa-navbar"
			>
				<router-link :to="{ name: 'home' }">
					<v-img :src="logoImg" :max-width="logoWidth" contain class="ml-6"></v-img>
				</router-link>

				<v-spacer></v-spacer>

				<v-btn
					text
					color="#882182"
					class="company-login-btn px-3 text-capitalize"
					rounded
					outlined
					href="https://company-dashboard.forsabarter.com/login"
					target="_blank"
					:height="36"
					:style="{ fontSize: buttonFontSize }"
				>
					{{$t('company-login')}}
				</v-btn>
				<v-btn
					:ripple="false"
					text
					rounded
					class="text-capitalize"
					:class="locale === 'en' ? 'ml-2' : 'mr-2'"
					min-width="0"
					:height="36"
					:style="{ fontSize: buttonFontSize }"
					@click="changeLang()"
				>
					{{$t('lang')}}
				</v-btn>
			</v-app-bar>

			<v-main class="forsa-content">
				<router-view/>
			</v-main>
		</div>
		<v-divider/>
		<m-footer/>
	</v-app>
</template>

<script>
import MFooter from './components/Footer.vue';
const logoImg = require('@/assets/logo.png');

export default {
	components: { MFooter },

	data() {
		return {
			logoImg,
		}
	},
	
	computed: {
		buttonFontSize() {
			if (this.$vuetify.breakpoint.width < 375) return '0.75rem';
			if (this.$vuetify.breakpoint.width < 768) return '0.85rem';
			return '1rem';
		},

		logoWidth() {
			if (this.$vuetify.breakpoint.width < 425) return '120px';
			if (this.$vuetify.breakpoint.width < 768) return '140px';
			return '160px';
		},
	},
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Cairo:wght@400;500;600;700&display=swap");
@import '@/scss/global.scss';

.forsa-content {
	min-height: 60vh;
}
</style>